const testimonials = [
  {
    id: 1,
    name: "Shaif Arfan",
    title: "CEO",
    org: "WEB CIFAR",
    desc: "Tchinonso is a person of commitment. He is really good at what he is doing. I really like his work. Especially the unique point of view of designing.",
  },
  {
    id: 2,
    name: "Fahim Elahe",
    title: "Co-founder",
    org: "Kreetive",
    desc: "Really amazing communication skills. Always understand what I am trying to achieve. Also, his work is really amazing. Do really high-quality work.",
  },
  {
    id: 3,
    name: "Sayed",
    title: "Marketing Head",
    org: "Eleven Dawn",
    desc: "Really hard-working person. Deliver the work as promised. Planning to work more with this person.",
  },
  {
    id: 4,
    name: "Mr Christian",
    title: "CEO",
    org: "Pimallmetro",
    desc: "Really amazing and focused on his career. It was my pleasure working with this guy.",
  },
  {
    id: 5,
    name: "Mr Precious",
    title: "HR",
    org: "PiFortune",
    desc: "I had a one time contract job with this guy and it was amazing, i can't wait to do more business with him.",
  },
];
export default testimonials;
